function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon/Export_two_tone");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/Export",
  stroke: "#CC31FF"
}, /*#__PURE__*/React.createElement("line", {
  x1: 5.54720317,
  y1: 4.5,
  x2: 5.54720317,
  y2: 19.9891704,
  id: "Path-3",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 11.5472032,
  y1: 4.5,
  x2: 11.5472032,
  y2: 19.9891704,
  id: "Path-3-Copy",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 17.5472032,
  y1: 4.5,
  x2: 17.5472032,
  y2: 19.9891704,
  id: "Path-3-Copy-2",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  cx: 5.5,
  cy: 16,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-2",
  fill: "#FFFFFF",
  cx: 17.5,
  cy: 14,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy",
  fill: "#CC31FF",
  cx: 11.5,
  cy: 10,
  r: 2
})));

var SvgExport = function SvgExport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/export.972cf1c1.svg";
export { ForwardRef as ReactComponent };